import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

interface IGetEstados {
  codUf: number;
  uf: string;
  descricao: string;
}

export interface IGetEstadosResponse {
  estados: IGetEstados[];
}

export const SelectEstadoService = {
  getEstados: (): Promise<AxiosResponse<IGetEstadosResponse>> =>
    UDNICK.callService('getEstados', {}),
};
